module.exports = __webpack_public_path__ + "static/media/sc_15_i.7052264b.png";